<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="dialogVisible = true">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      stripe
      default-expand-all
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">

      <el-table-column
        prop="name"
        label="模块"
        width="300">
      </el-table-column>
      <el-table-column
        prop="free"
        :label="planNames.first || '体验'"
        width="180">
      </el-table-column>
      <el-table-column
        prop="basics"
        :label="planNames.second || '个人'"
        width="180">
      </el-table-column>
      <el-table-column
        prop="major"
        :label="planNames.third || '团队'"
        width="180">
      </el-table-column>
      <el-table-column
        prop="corp"
        label="企业"
        width="180">
      </el-table-column>
      <el-table-column
        prop="sort"
        label="序号"
        width="180">
      </el-table-column>
      <el-table-column
        prop="icon"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
          <el-divider direction="vertical"></el-divider>

          <template>
            <el-popconfirm title="这是一段内容确定删除吗？" @confirm="delHandle(scope.row.id)">
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>

        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editForm" :label-width="'120px'" class="demo-editForm">
        <el-form-item label="上级菜单" prop="parentId">
          <el-select v-model="editForm.parentId" placeholder="请选择上级菜单">
              <el-option v-for="item in tableData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模块名称" prop="name">
          <el-input class="form-input" v-model="editForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="planNames.first || '体验'" prop="free">
          <el-input class="form-input" v-model="editForm.free" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="planNames.second || '个人'" prop="basics">
          <el-input class="form-input" v-model="editForm.basics" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="planNames.third || '团队'" prop="major">
          <el-input class="form-input" v-model="editForm.major" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="企业" prop="corp">
          <el-input class="form-input" v-model="editForm.corp" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="sort">
          <el-input class="form-input" v-model="editForm.sort" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item style="text-align: right;">
          <el-button @click="resetForm('editForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('editForm')">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { getPlanNamesMap } from '@/utils/planNames'
  
  export default {
    name: "planOverview",
    data() {
      return {
        dialogVisible: false,
        tableData: [{
          id: ''
        }],
        editForm: {},
        planNames: {
          first: '体验',
          second: '个人',
          third: '团队'
        },
        editFormRules: {
          name: [
            {required: true, message: '请输入模块名称', trigger: 'blur'}
          ],
        }
      }
    },
    created() {
      this.getPlanOverviewTree();
      this.loadPlanNames();
    },
    methods: {
      // 加载订阅计划名称
      loadPlanNames() {
        this.$axios.get("/uxm/config/list", {}).then(res => {
          if (res && res.data && res.data.data) {
            const planNamesMap = getPlanNamesMap(res.data.data)
            this.planNames = planNamesMap
          }
        }).catch(error => {
          console.error('获取订阅计划名称失败:', error)
        })
      },
      getPlanOverviewTree() {
        this.$axios.get("/uxm/subscribe-plan/list").then(res => {
          this.tableData = res.data.data
        })
      },
      editHandle(id) {
        this.$axios.get('/uxm/subscribe-plan/info/' + id).then(res => {
          this.editForm = res.data.data

          this.dialogVisible = true
        })
      },
      delHandle(id) {
        this.$axios.post("/uxm/subscribe-plan/delete/" + id).then(res => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          });
          this.getPlanOverviewTree();
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.dialogVisible = false
        this.editForm = {}
      },
      handleClose() {
        this.resetForm('editForm')
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/uxm/subscribe-plan/' + (this.editForm.id?'update' : 'save'), this.editForm)
              .then(res => {
                this.$message({
                  showClose: true,
                  message: '恭喜你，操作成功',
                  type: 'success',
                });
                this.getPlanOverviewTree()
                this.dialogVisible = false
                this.resetForm('editForm')
              })
          }
        });
      }
    }
  }
</script>

<style>
  .form-input {
    width: 80%;
  }
</style>
